/**
 * Icono de Usuario para la navegación inferior
 * Adaptado de la versión móvil (Usercito)
 * Cambia de opacidad según el estado activo
 */

import React from 'react';

const UserIcon = ({ active = false, size = 26, color = '#A89CA6', className = '' }) => {
  // Color activo: blanco, Color inactivo: gris terciario
  const iconColor = active ? '#f7f7f8' : color;
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill={iconColor}
      className={className}
    >
      {active ? (
        // Versión activa - círculo de cabeza sin opacidad
        <>
          <path d="M192 96a64 64 0 1 1-64-64 64 64 0 0 1 64 64Z" opacity={1} />
          <path d="M230.92 212c-15.23-26.33-38.7-45.21-66.09-54.16a72 72 0 1 0-73.66 0c-27.39 8.94-50.86 27.82-66.09 54.16a8 8 0 1 0 13.85 8c18.84-32.56 52.14-52 89.07-52s70.23 19.44 89.07 52a8 8 0 1 0 13.85-8ZM72 96a56 56 0 1 1 56 56 56.06 56.06 0 0 1-56-56Z" />
        </>
      ) : (
        // Versión inactiva - círculo de cabeza con opacidad
        <>
          <path d="M192 96a64 64 0 1 1-64-64 64 64 0 0 1 64 64Z" opacity={0.2} />
          <path d="M230.92 212c-15.23-26.33-38.7-45.21-66.09-54.16a72 72 0 1 0-73.66 0c-27.39 8.94-50.86 27.82-66.09 54.16a8 8 0 1 0 13.85 8c18.84-32.56 52.14-52 89.07-52s70.23 19.44 89.07 52a8 8 0 1 0 13.85-8ZM72 96a56 56 0 1 1 56 56 56.06 56.06 0 0 1-56-56Z" />
        </>
      )}
    </svg>
  );
};

export default UserIcon;
